import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { NewsletterIssues } from './NewsletterIssues';
import { NewsletterEmbed } from '../NewsletterEmbed';
export function ResourcesNewsletter() {
  return <section className="w-full bg-brand-light-gray py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-184" data-mp="edm6qejuey6w">
      <div className="max-w-4xl mx-auto" data-id="element-185" data-mp="9fu70ycyi7s5">
        <div className="bg-white p-10 md:p-16 rounded-lg shadow-sm border-t-4 border-brand-orange" data-id="element-186" data-mp="9eswqw3rlpbh">
          <h2 className="text-4xl md:text-5xl font-bold text-brand-navy mb-8" data-id="element-187" data-mp="5f1vfygm3qsp">
            Broken Pencils
          </h2>
          <p className="text-xl text-brand-gray leading-relaxed mb-12" data-id="element-188" data-mp="l60z5zk4m2a">
            A newsletter about AI transformation, leadership, and the
            messy reality of getting teams to work differently. Published every
            other week. Read by leaders figuring out what AI means for how
            their teams work.
          </p>

          <div className="bg-brand-light-gray p-8 rounded-lg mb-10 border border-gray-100 shadow-sm" data-id="element-189" data-mp="3dtahsosjjlcf">
            <NewsletterEmbed data-id="element-190" data-mp="3jxsrqtf4p0oa" />
          </div>

          <NewsletterIssues data-id="element-191" data-mp="3jwr6jw4eexsu" />

          <a href="https://newsletter.breakapencil.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center font-bold text-brand-orange hover:text-brand-orange-hover transition-colors text-lg" data-id="element-192" data-mp="3oq2ddx97nekr">
            Read past issues
            <ArrowRightIcon className="w-5 h-5 ml-2" data-id="element-193" data-mp="6jo102qlbcoh" />
          </a>
        </div>
      </div>
    </section>;
}